// https://docs.microsoft.com/pt-br/azure/cognitive-services/speech-service/language-support

import * as React from 'react';

// styles
const pageStyles = {
  color: '#232129',
  padding: '96px',
  fontFamily: '-apple-system, Roboto, sans-serif, serif',
};
const headingStyles = {
  marginTop: 0,
  marginBottom: 64,
  maxWidth: 320,
};
const headingAccentStyles = {
  color: '#663399',
};
const listStyles = {
  marginBottom: 96,
  paddingLeft: 0,
};
const listItemStyles = {
  fontWeight: '300',
  fontSize: '24px',
  maxWidth: '560px',
};

// $$("#main > div:nth-child(8) > table > tbody > tr > td:nth-child(1) > span:nth-child(1)").map((s) => s.innerText)
const language = ['Árabe (Bahrein), padrão moderno', 'Árabe (Egito)', 'Árabe (Iraque)', 'Árabe (Israel)', 'Árabe (Jordânia)', 'Árabe (Kuwait)', 'Árabe (Líbano)', 'Árabe (Omã)', 'Árabe (Catar)', 'Árabe (Arábia Saudita)', 'Árabe (estado de Palestina)', 'Árabe (Síria)', 'Árabe (Emirados Árabes Unidos)', 'Búlgaro (Bulgária)', 'Catalão (Espanha)', 'Chinês (Cantonês tradicional)', 'Chinês (mandarim, simplificado)', 'Chinês (Mandarim Taiwanês)', 'Croata (Croácia)', 'Tcheco (República Tcheca)', 'Dinamarquês (Dinamarca)', 'Holandês (Países Baixos)', 'Inglês (Austrália)', 'Inglês (Canadá)', 'Inglês (Hong Kong)', 'Inglês (Índia)', 'Inglês (Irlanda)', 'Inglês (Nova Zelândia)', 'Inglês (Nigéria)', 'Inglês (Filipinas)', 'Inglês (Singapura)', 'Inglês (África do Sul)', 'Inglês (Reino Unido)', 'Inglês (Estados Unidos)', 'Estoniano (Estônia)', 'Finlandês (Finlândia)', 'Francês (Canadá)', 'Francês (França)', 'Alemão (Alemanha)', 'Grego (Grécia)', 'Guzerate (Índia)', 'Híndi (Índia)', 'Húngaro (Hungria)', 'Irlandês (Irlanda)', 'Italiano (Itália)', 'Japonês (Japão)', 'Coreano (Coreia do Sul)', 'Letão (Letônia)', 'Lituano (Lituânia)', 'Maltês (Malta)', 'Marati (Índia)', 'Norueguês, (Bokmål, Noruega)', 'Polonês (Polônia)', 'Português (Brasil)', 'Português (Portugal)', 'Romeno (Romênia)', 'Russo (Rússia)', 'Eslovaco (Eslováquia)', 'Esloveno (Eslovênia)', 'Espanhol (Argentina)', 'Espanhol (Bolívia)', 'Espanhol (Chile)', 'Espanhol (Colômbia)', 'Espanhol (Costa Rica)', 'Espanhol (Cuba)', 'Espanhol (República Dominicana)', 'Espanhol (Equador)', 'Espanhol (El Salvador)', 'Espanhol (Guiné Equatorial)', 'Espanhol (Guatemala)', 'Espanhol (Honduras)', 'Espanhol (México)', 'Espanhol (Nicarágua)', 'Espanhol (Panamá)', 'Espanhol (Paraguai)', 'Espanhol (Peru)', 'Espanhol (Porto Rico)', 'Espanhol (Espanha)', 'Espanhol (Uruguai)', 'Espanhol (EUA)', 'Espanhol (Venezuela)', 'Sueco (Suécia)', 'Tâmil (Índia)', 'Télugo (Índia)', 'Tailandês (Tailândia)', 'Turco (Turquia)'];

// markup
const IdiomasTranscricao = () => (
  <main style={pageStyles}>
    <title>Idiomas suportados</title>
    <h1 style={headingStyles}>
      Quais idiomas são suportados?
      <br />
      <span style={headingAccentStyles}>— you just made a Gatsby site! </span>
      <span role="img" aria-label="Party popper emojis">
        🎉🎉🎉
      </span>
    </h1>
    <ul style={listStyles}>
      {language.map((item) => (
        <li key={item} style={{ ...listItemStyles }}>
          <span>
            {item}
          </span>
        </li>
      ))}
    </ul>
    <img
      alt="Gatsby G Logo"
      src="data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2a10 10 0 110 20 10 10 0 010-20zm0 2c-3.73 0-6.86 2.55-7.75 6L14 19.75c3.45-.89 6-4.02 6-7.75h-5.25v1.5h3.45a6.37 6.37 0 01-3.89 4.44L6.06 9.69C7 7.31 9.3 5.63 12 5.63c2.13 0 4 1.04 5.18 2.65l1.23-1.06A7.959 7.959 0 0012 4zm-8 8a8 8 0 008 8c.04 0 .09 0-8-8z' fill='%23639'/%3E%3C/svg%3E"
    />
  </main>
);

export default IdiomasTranscricao;
